<template>
  <header class="items-center">
    <h1 class="header__h1 mb-5">Say 'Hello World' with our API</h1>
    <p class="header__p mb-5">API calls and requests for your service website</p>
    <div class="my-base">
        <vs-button href="/parser" target type="border" color="white" class="mr-3">TRY DEMO</vs-button>
        <vs-button href="https://api.getboarded.tech/api/docs" target type="filled" color="white" text-color="#F29300">API Documentation</vs-button>
    </div>
  </header>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>

  header {
    width: 100%;
    padding: 10rem;
    background: linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%);
  }

  /*===============================================*/
  /* Header		 						 */
  /*===============================================*/

  .header__h1 {
    font-style: normal;
    font-weight: 800;
    font-size: 50px;
    line-height: 115%;
    letter-spacing: -0.04em;
    color: #FFFFFF;
  }
  .header__p {
    width: 60%;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 35px;
    text-align: center;
    letter-spacing: -0.01em;
    color: #FFFFFF;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    header {
      width: 100%;
      padding: 10rem 2rem;
      background: linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%);
    }
  }
</style>
